import { Field, FormikProvider } from "formik"
import React, { useEffect, useRef, useState } from "react"
import { Button, Card } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { CardBody } from "../../../../../../_metronic/_partials/controls/index.js"
import { RowModule } from "../../../../../../component/atoms/RowModule/RowModule.jsx"
import {
  EmptyCard,
  Search,
  SelectInput,
  Text2Row,
  TextAreaInput,
  TextInput
} from "../../../../../../component/index.jsx"
import { getUrlParsing } from "../../../../../../config/EndpointCollection.js"
import { ICON_CONSTANTS } from "../../../../../../constants/ImageConstants.js"
import { DATE_TYPE_ENUM, REASON } from "../../../../../../constants/StringConstant.js"
import {
  getListChildReason,
  getListPest,
  getListReasonReportBa
} from "../../../../../../redux/actions/ReportActivityAction.jsx"
import { timeStampToDate } from "../../../../../helpers/DateHelper.js"
import {
  convertM2ToHectareParseFloat,
} from "../../../../../helpers/TextHelper.js"
import OverviewArea from "../components/OverviewArea.jsx"
import { Popup } from "../../../../../../component/atoms/Popup/index.jsx"
import { ButtonWithIcon } from "../../../../../../component/atoms/Button/ButtonWithIcon.jsx"
import SVG from "react-inlinesvg"
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers/index.js"

export const FillAreaDetail = ({ activeStep, setActiveStep, formik, dispatch, dataInit }) => {
  const { t } = useTranslation()
  const [stateReason, setStateReason] = useState([])
  const [stateChildReason, setStateChildReason] = useState([])
  const [statePest, setStatePest] = useState([])
  const [buttonDisabled, setButtonDisabled] = useState(false)
  const formReasonRef = useRef()
  const [reasonSearch, setReasonSearch] = useState({ keyword: "" })
  const [isReasonSearchActive, setIsReasonSearchActive] = useState(false)
  const [showReasonPopup, setShowReasonPopup] = useState(false)
  const [activePopupIndex, setActivePopupIndex] = useState(null)
  const { ReportActivity } = useSelector((state) => state)

  useEffect(() => {
    dispatch(getListReasonReportBa())
    checkDisable()
  }, [])

  useEffect(() => {
    setStateReason(
      ReportActivity.listReason.map((value) => ({
        value: value.id,
        label: value.name
      }))
    )
  }, [ReportActivity.listReason])

  useEffect(() => {
    if (ReportActivity.listChildReason.length) {
      const stateChildReason = ReportActivity.listChildReason.map((value) => {
        if (Array.isArray(value) && value.length > 0) {
          return value.map((item) => ({
            value: item.id,
            label: item.name
          }))
        }
        return []
      })
      setStateChildReason(stateChildReason)
    }
  }, [ReportActivity.listChildReason])

  useEffect(() => {
    checkDisable()
  }, [formik.values.area])

  useEffect(() => {
    if (ReportActivity?.listPest) {
      const statePest = ReportActivity?.listPest.map((value) => {
        if (Array.isArray(value) && value.length > 0) {
          return value.map((item) => ({
            value: item.id,
            label: item.name,
            checked: false
          }))
        }
        return []
      })
      setStatePest(statePest)
    }
  }, [ReportActivity.listPest])

  const isRowValid = (e) => {
    if (!e.activity_date || !e.reason_id) return false
    if (e.reason_id === REASON.PEST) {
      return Array.isArray(e.pest_id) && e.pest_id.length > 0
    }
    if (e.reason_id === REASON.OTHER_PARENT) {
      return !!e.reason_string
    }
    if (e.reason_id === REASON.DISASTER) {
      if (!e.reason_id_child) return false
      if (e.reason_id_child === REASON.OTHER_DISASTER) return !!e.reason_string
      return true
    }
    return true
  }

  const checkDisable = () => {
    const data = formik.values.area
    const allValid = data.length > 0 && data.every((e) => isRowValid(e))
    setButtonDisabled(!allValid)
  }

  const listFormArea = (
    <div className={"mt-10"}>
      <h4 className={"mb-10"}>Daftar Lahan Terpilih</h4>
      {formik?.values?.area &&
        formik?.values?.area.map((item, index) => {
          return (
            <Card className={"mb-4"} key={index}>
              <CardBody>
                <h4 className={"mb-8"}>{item.area_name}</h4>
                <div className={"row ml-0 mb-8"}>
                  <Text2Row title={t("label_block_name")} description={item.block_code} />
                  <Text2Row title={t("label_farmer_name")} description={item.farmer_name} />
                  <Text2Row
                    title={t("label_area")}
                    description={`${convertM2ToHectareParseFloat(item.planting_area)} Ha`}
                  />
                  <Text2Row title={t("label_plant_varieties")} description={item.variety_name} />
                  <Text2Row
                    title={t("label_planting_date")}
                    description={`${timeStampToDate(
                      item.planting_date,
                      DATE_TYPE_ENUM.ISO_DATE_STRAP
                    )} (${item.hst} HST)`}
                  />
                </div>
                <RowModule customSeparator={"mb-8"}>
                  <TextInput
                    required
                    editable={true}
                    label={t("label_land_clearing_activity_date")}
                    placeholder={t("placeholder_select_date")}
                    name={`area.${index}.activity_date`}
                    type={"date"}
                    value={formik.values.area[index]?.activity_date}
                  />
                </RowModule>
                <RowModule customSeparator={"mb-8"}>
                  <SelectInput
                    name={`area.${index}.reason_id`}
                    required
                    editable={true}
                    label={t("label_land_clearing_reasong")}
                    placeholder={t("placeholder_select_one")}
                    options={stateReason}
                    value={formik.values.area[index]?.reason_id}
                    onChange={(values) => {
                      formik.setFieldValue(`area.${index}.pest_id`, null)
                      formik.setFieldValue(`area.${index}.reason_string`, "")
                      formik.setFieldValue(`area.${index}.reason_id_child`, null)
                      formik.setFieldValue(`area.${index}.reason_id`, values).then(() => {
                        if (values === REASON.DISASTER) {
                          let param = ""
                          param = getUrlParsing(param, "parent_id", values)
                          formik.setFieldValue(`area.${index}.checkValue`, false)
                          dispatch(getListChildReason(param, index))
                        } else if (values === REASON.OTHER_PARENT) {
                          formik.setFieldValue(`area.${index}.checkValue`, false)
                        } else if (values === REASON.PEST) {
                          formik.setFieldValue(`area.${index}.checkValue`, false)
                          dispatch(getListPest(formik.values.area[index].plant_type_id, index))
                        } else {
                          if (values) {
                            formik.setFieldValue(`area.${index}.checkValue`, true)
                          } else {
                            formik.setFieldValue(`area.${index}.checkValue`, false)
                          }
                        }
                      })
                    }}
                  />
                </RowModule>
                {formik.values.area[index]?.reason_id === REASON.DISASTER && (
                  <RowModule>
                    <SelectInput
                      name={`area.${index}.reason_id_child`}
                      required
                      onChange={(e) => {
                        if (e === REASON.OTHER_DISASTER) {
                          formik.setFieldValue(`area.${index}.checkValue`, false)
                        } else {
                          if (e) {
                            formik.setFieldValue(`area.${index}.checkValue`, true)
                            formik.setFieldValue(`area.${index}.reason_string`, "")
                          } else {
                            formik.setFieldValue(`area.${index}.checkValue`, false)
                          }
                        }
                      }}
                      editable={true}
                      label={t("placeholder_disaster_type")}
                      placeholder={t("placeholder_select_one")}
                      options={stateChildReason[index]}
                      value={formik.values.area[index]?.reason_id_child}
                    />
                  </RowModule>
                )}
                {formik.values.area[index]?.reason_id === REASON.PEST && (
                  <div>
                    <Popup
                      show={showReasonPopup && activePopupIndex === index}
                      size={"md"}
                      titleCustom={<h2>{t("label_choose_pest_type")}</h2>}
                      contentClassName={"modal-main"}
                      closeButton={true}
                      onCancel={() => {
                        setShowReasonPopup(false)
                      }}
                      showButton={false}
                      bodyCustom={
                        <div className={"filter-container"}>
                          <div className={"position-relative d-flex flex-wrap justify-content-center align-items-center mb-8"}>
                            <Search
                              customClass={"w-full"}
                              placeholder={t("placeholder_select_pest")}
                              onSubmitForm={(e) => setReasonSearch({ keyword: e.keyword })}
                              initialValues={reasonSearch}
                              isActiveSearch={isReasonSearchActive}
                              innerRef={formReasonRef}
                              name={"keyword"}
                              trigerReset={() => {
                                setReasonSearch({ keyword: "" })
                                setIsReasonSearchActive(false)
                              }}
                            />
                          </div>
                          <div className={"d-flex flex-column justify-content-start max-height-50 overflow-auto"}>
                          {
                            statePest[index] && statePest[index]
                              .filter((item) => item.label.match(new RegExp(reasonSearch.keyword, "i")))
                              .map((pestItem) => (
                                <div key={pestItem.value} className={"checkbox-green d-flex align-items-center mb-6"}>
                                  <input
                                    type="checkbox"
                                    id={`pest_${index}_${pestItem.value}`}
                                    checked={!!pestItem.selected}
                                    // disabled={Array.isArray(formik.values.area[index]?.pest_id) && formik.values.area[index].pest_id.includes(pestItem.value)}
                                    style={{
                                      cursor: Array.isArray(formik.values.area[index]?.pest_id) && formik.values.area[index].pest_id.includes(pestItem.value)
                                        ? "not-allowed"
                                        : "pointer"
                                    }}
                                    onChange={() => {
                                      setStatePest((prevState) => {
                                        const newState = [...prevState]
                                        const pestIndex = newState[index].findIndex((item) => item.value === pestItem.value)
                                        if (pestIndex !== -1) {
                                          newState[index][pestIndex].selected = !newState[index][pestIndex].selected
                                        }
                                        return newState
                                      })
                                    }}
                                  />
                                  <label htmlFor={`pest_${index}_${pestItem.value}`} className={"mb-0 font-size-lg ml-4 pointer"}>
                                    {pestItem.label}
                                  </label>
                                </div>
                              ))
                          }
                          </div>
                          {
                            statePest[index] && statePest[index]
                              .filter((item) => item.label.match(new RegExp(reasonSearch.keyword, "i")))
                              .length === 0 ? (
                              <EmptyCard body={"Data tidak ditemukan"} />
                            ) : <></>
                          }
                          <div className={"d-flex justify-content-end"}>
                            <Button
                              className="font-weight-bold btn-block mt-2 fit-content"
                              type={"submit"}
                              variant={"primary"}
                              disabled={
                                !statePest[index] ||
                                statePest[index].filter((item) => item.selected).length === 0
                              }
                              onClick={() => {
                                const selected = statePest[index].filter((item) => item.selected).map((item) => item.value)
                                formik.setFieldValue(`area.${index}.pest_id`, selected)
                                setStatePest((prevState) =>
                                  prevState.map((pestList, i) => {
                                    if (i !== index) return pestList
                                    return pestList.map((item) => ({ ...item, selected: false }))
                                  })
                                )
                                setShowReasonPopup(false)
                              }}>
                              Tambahkan
                            </Button>
                          </div>
                        </div>
                      }
                    />
                    <label>
                      {t("label_pest")} <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className={"d-flex flex-wrap mb-4"}>
                      {formik.values.area[index]?.pest_id && Array.isArray(formik.values.area[index]?.pest_id) &&
                        statePest[index] &&
                        statePest[index]
                          .filter((opt) => formik.values.area[index]?.pest_id.includes(opt.value))
                          .map((item, i) => {
                            return (
                              <label
                                key={i}
                                htmlFor={name + item.value}
                                className="label-container mx-2 my-2 btn-filter">
                                <Field
                                  type={"checkbox"}
                                  name={name}
                                  key={item.value}
                                  value={item.value}
                                  id={name + item.value}
                                  className={"hidden"}
                                  checked={true}></Field>
                                <div className={"label-filter d-flex align-items-center fit-content"}>
                                  {item.label}
                                  <div
                                    onClick={() => {
                                      formik.setFieldValue(`area.${index}.pest_id`, formik.values.area[index].pest_id.filter((value) => value !== item.value))
                                    }}>
                                    <SVG
                                      className={"ml-2 icon-checkbox-label"}
                                      src={toAbsoluteUrl(ICON_CONSTANTS.MINI_CLOSE)}
                                    />
                                  </div>
                                </div>
                              </label>
                            )
                          })}
                    </div>
                    <ButtonWithIcon
                      label={t("button_add_pest_type")}
                      icon={ICON_CONSTANTS.PLUS_PRIMARY}
                      onClick={() => {
                        setActivePopupIndex(index)
                        setReasonSearch({ keyword: "" })
                        setIsReasonSearchActive(false)
                        const currentPestIds = formik.values.area[index]?.pest_id ?? []
                        setStatePest((prevState) => {
                          const newState = [...prevState]
                          if (newState[index]) {
                            newState[index] = newState[index].map((item) => ({
                              ...item,
                              selected: Array.isArray(currentPestIds) && currentPestIds.includes(item.value)
                            }))
                          }
                          return newState
                        })
                        setShowReasonPopup(true)
                      }}
                      className={"text-primary"}
                    />
                  </div>
                )}
                {(formik.values.area[index]?.reason_id === REASON.OTHER_PARENT ||
                  formik.values.area[index]?.reason_id_child === REASON.OTHER_DISASTER) && (
                  <RowModule>
                    <TextAreaInput
                      editable={false}
                      name={`area.${index}.reason_string`}
                      placeholder={t("placeholder_input_description")}
                      type={"text"}
                      value={formik.values.area[index]?.reason_string}
                      onKeyUp={(e) => {
                        const value = e.target.value
                        formik.setFieldValue(`area.${index}.checkValue`, !!value)
                      }}
                    />
                  </RowModule>
                )}
              </CardBody>
            </Card>
          )
        })}
    </div>
  )

  return (
    <div className={"d-flex justify-content-center w-full py-6"}>
      <div className={"w-80vw"}>
        {dataInit && <OverviewArea dataInit={dataInit} />}
        <FormikProvider value={formik}>{listFormArea}</FormikProvider>
        <div className={"d-flex justify-content-end align-items-center"}>
          <Button
            variant={"secondary"}
            onClick={() => {
              setActiveStep(activeStep - 1)
            }}
            className={"d-flex align-items-center color-primary mr-8"}>
            {t("button_previous")}
          </Button>
          <Button
            variant={"primary"}
            disabled={buttonDisabled}
            onClick={() => setActiveStep(activeStep + 1)}
            className={"d-flex align-items-center color-primary"}>
            {t("button_upload_ba")}
            <img alt={""} src={ICON_CONSTANTS.ARROW_RIGHT_WHITE} className={"ml-2"} />
          </Button>
        </div>
      </div>
    </div>
  )
}